import './DrinkOptionsSelector.less';

const DrinkOptionsSelector = ({ options, preselectedOptionIds = [], onClick }) => {
	const handleOnClick = (e, customizationId, item) => {
		const target = e.currentTarget;
		const parent = target.parentElement;
		const currentSelection = parent.querySelector('.selected');

		if (currentSelection)
			currentSelection.classList.remove('selected');

		e.currentTarget.classList.add('selected');
		onClick(customizationId, item);
	};

	return (
		options.map((customization) => (
			<>
				<div
					style={{ marginBlock: 16, fontWeight: 500 }}
					key={customization._id}
				>
					{
						customization.is_required ?
							(
								<>
									{customization.name}
									<span style={{ marginInlineStart: 8, color: '#8C8C8C' }}>(Required)</span>
								</>
							) :
							customization.name
					}
				</div>
				<div className="drink-options-list">
					{
						customization?.options && customization.options.length ?
							customization.options.map((option, key) => (
								<div
									onClick={(e) => handleOnClick(e, customization._id, option)}
									className={`drink-options-list-item ${preselectedOptionIds.includes(option._id) ? 'selected' : null}`}
									key={`${customization._id}_${key}`}
								>
									<span className="item-name">{option.label}</span>
									<span className="item-price">
										{option.price >= 0 ? '+' : '-'} ${option.price >= 0 ? option.price.toFixed(2) : Math.abs(option.price).toFixed(2)}
									</span>
								</div>
							)) : null
					}
				</div>
			</>
		))
	);
};

export default DrinkOptionsSelector;